import { Flex, Text } from '@radix-ui/themes'
import { IconInfoCircleFilled } from '@tabler/icons-react'
import { PracticeTestDetail } from '@/types/practice-test'
import Stack from '@/components/ui/stack'
import QuestionList from './question-list'

interface PreviewProps {
  practiceTestData?: PracticeTestDetail
  doingTime?: number
}

export default function Preview({ practiceTestData }: PreviewProps) {
  return (
    <Flex direction={'column'} gap='4' p='4' className='bg-white'>
      <Flex
        direction='row'
        align='center'
        gap='2'
        className='rounded-[16px] border bg-[#C2DEFF] p-4 text-[16px] font-normal text-[#00397A]'
      >
        <IconInfoCircleFilled size={24} color='#0069E0' />
        <Stack gap={'0'}>
          <Text>
            The scenarios included here are entirely fictional. Any resemblance
            of the information in the scenarios to real persons or
            organizations, actual or perceived, is purely coincidental.
          </Text>
        </Stack>
      </Flex>

      {(practiceTestData?.general_information !== null && practiceTestData?.general_information !== '<p></p>') && (
        <div className='py-2'>
          <Text className='text-[24px] font-[400] text-[#002652]'>
            General Information
          </Text>
          {practiceTestData?.general_information && (
            <div
              className='prose max-w-none'
              dangerouslySetInnerHTML={{
                __html: practiceTestData.general_information as string,
              }}
            />
          )}
        </div>
      )}
      <QuestionList practiceTestData={practiceTestData} />
    </Flex>
  )
}
